import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import * as routes from '../utils/routes';
import "../landing-page.css";

export function LandingPage() {
	const [isScrolled, setIsScrolled] = useState(false);
	const [billingInterval, setBillingInterval] = useState<'monthly' | 'yearly'>('monthly');

	useEffect(() => {
		const handleScroll = () => {
			const heroSection = document.querySelector('.hero-section') as HTMLElement;
			if (heroSection) {
				const heroBottom = heroSection.offsetTop + heroSection.offsetHeight;
				const scrollPosition = window.scrollY;
				setIsScrolled(scrollPosition > heroBottom - 100);
			}
		};

		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, []);

	return (
		<div className="landing-page">
			<header className={`main-header ${isScrolled ? 'scrolled' : ''}`}>
				<div className="container">
					<nav className="main-nav">
						<div className="logo">Vend<span className="ready">Ready</span></div>
						<div className="nav-center" style={{ position: 'relative', left: '10px' }}>
							<a href="#why-vendready" className="nav-link">Why VendReady</a>
							<a href="#features" className="nav-link">Features</a>
							<a href="#testimonials" className="nav-link">Testimonials</a>
							<a href="#pricing" className="nav-link">Pricing</a>
						</div>
						<div className="nav-right">
							<Link to={routes.LOGIN} className="btn-signin">Login</Link>
							<Link to={routes.REGISTER} className="btn btn-demo">Start Free Trial</Link>
						</div>
					</nav>
				</div>
			</header>

			<section className="hero-section">
				<div className="container">
					<div className="hero-content-wrapper">
						<div className="hero-left">
							<h1 className="hero-title">Manage Orders,<br /> Payments and Inventory</h1>
							<p className="hero-subtitle">
								Built for businesses and social media sellers. Stay organized, save time, never miss sales.
							</p>
							{/* <div className="hero-ratings">
								<div className="rating-stars">
									<span className="rating-badge">G</span>
									<span className="rating-text">4.8 stars</span>
									<span className="rating-reviews">2,000+ reviews</span>
								</div>
								<a href="#" className="explore-link">Explore product →</a> 
							</div> */}
							{/* <div className="hero-signup"> */}
							<a
								href="https://form.typeform.com/to/n0vb387q"
								target="_blank"
								rel="noopener noreferrer"
								className="btn btn-primary btn-large"
							>
								Book a demo
							</a>
							{/* </div> */}
						</div>
						<div className="hero-right">
							<div className="hero-mockup">
								<img src="landing-page/dashboard.png" alt="VendReady Dashboard" className="hero-image" />
							</div>
							<div className="hero-mockup mobile-mockup">
								<img src="landing-page/dashboard-responsive.png" alt="VendReady Dashboard Responsive" className="hero-image" />
							</div>
						</div>
					</div>
				</div>
			</section>

			{/* <section className="social-proof">
				<div className="container">
					<p className="social-proof-text">30,000+ finance teams have saved millions of hours with VendReady.</p>
					<div className="company-logos">
						<div className="logo-item">eventbrite</div>
						<div className="logo-item">VALCOURT</div>
						<div className="logo-item">ANDURIL</div>
						<div className="logo-item">shopify</div>
						<div className="logo-item">Opendoor</div>
						<div className="logo-item">ZOLA</div>
						<div className="logo-item">KUMON</div>
					</div>
				</div>
			</section> */}

			<section className="benefits-overview" id="why-vendready">
				<div className="container">
					<div className="section-header">
						<p className="section-label">VENDREADY FEATURE SUITE</p>
						<h2 className="section-title">Why you need VendReady</h2>
						<p className="section-description">VendReady is an all-in-one platform designed from the ground up to make business management faster—and stress-free.</p>
					</div>
					<div className="product-grid">
						<div className="product-card">
							<div className="product-icon">
								<img src="landing-page/svg/invoice.svg" alt="Professional Invoicing" />
							</div>
							<div className="product-content">
								<h3 className="product-title">Professional Invoicing</h3>
								<p className="product-description">Make your business standout and look professional with our branded invoices.</p>
							</div>
							<div className="product-arrow">→</div>
						</div>
						<div className="product-card">
							<div className="product-icon">
								<img src="landing-page/svg/storefront.svg" alt="Online Storefront" />
							</div>
							<div className="product-content">
								<h3 className="product-title">Online Storefront</h3>
								<p className="product-description">Accept orders 24/7 from customers with your very own online store</p>
							</div>
							<div className="product-arrow">→</div>
						</div>
						<div className="product-card">
							<div className="product-icon">
								<img src="landing-page/svg/inventory.svg" style={{ width: '40px', height: '40px' }} alt="Inventory Management" />
							</div>
							<div className="product-content">
								<h3 className="product-title">Inventory Management</h3>
								<p className="product-description">Never run out of products again with our inventory and stock management feature</p>
							</div>
							<div className="product-arrow">→</div>
						</div>
						<div className="product-card">
							<div className="product-icon">
								<img src="landing-page/svg/payment-tracking.svg" alt="Payment Tracking" />
							</div>
							<div className="product-content">
								<h3 className="product-title">Payment Tracking</h3>
								<p className="product-description">Know exactly who owes you money and how much they owe</p>
							</div>
							<div className="product-arrow">→</div>
						</div>
						<div className="product-card">
							<div className="product-icon">
								<img src="landing-page/svg/sales-analytics.svg" alt="Sales Analytics" />
							</div>
							<div className="product-content">
								<h3 className="product-title">Sales Analytics</h3>
								<p className="product-description">Discover trends and growth opportunities.</p>
							</div>
							<div className="product-arrow">→</div>
						</div>
						<div className="product-card">
							<div className="product-icon">
								<img src="landing-page/svg/expense-tracking.svg" alt="Expense Tracking" />
							</div>
							<div className="product-content">
								<h3 className="product-title">Expense Tracking</h3>
								<p className="product-description">Control costs and maximize profits.</p>
							</div>
							<div className="product-arrow">→</div>
						</div>
						<div className="product-card">
							<div className="product-icon">
								<img src="landing-page/svg/team-collaboration.svg" alt="Team Collaboration" />
							</div>
							<div className="product-content">
								<h3 className="product-title">Team Collaboration</h3>
								<p className="product-description">Add team members to your dashboard to help keep your business organized.</p>
							</div>
							<div className="product-arrow">→</div>
						</div>
						<div className="product-card">
							<div className="product-icon">
								<img src="landing-page/svg/invoice-read.svg" style={{ width: '35px', height: '35px' }} alt="Invoice Read Receipts" />
							</div>
							<div className="product-content">
								<h3 className="product-title">Invoice Read Receipts</h3>
								<p className="product-description">See when customers view invoices. No more stories</p>
							</div>
							<div className="product-arrow">→</div>
						</div>
					</div>
				</div>
			</section>

			<section className="main-features" id="features">
				<div className="container">
					<div className="feature-highlight">
						<div className="feature-content">
							<h2>Professional Invoicing</h2>
							<div className="feature-list">
								<div className="feature-item">
									<h4>Get Paid Faster, Every Time</h4>
									<p>Send branded invoices in seconds and get paid up to 40% faster</p>
								</div>
								<div className="feature-item">
									<h4>Payment Tracking</h4>
									<p>Never chase payments blindly - see exactly which invoices are overdue</p>
								</div>
								<div className="feature-item">
									<h4>Invoice Read Receipts</h4>
									<p>Know the moment customers view your invoices to follow up at the perfect time</p>
								</div>
							</div>
						</div>
						<div className="feature-image bordered-image">
							<img src="landing-page/invoice.png" alt="Invoice and Payment Tracking" />
						</div>
					</div>

					<div className="feature-highlight reverse">
						<div className="feature-content">
							<h2>Get An Online Store!</h2>
							<div className="feature-list">
								<div className="feature-item">
									<h4>Professional Online Storefront</h4>
									<p>Accept orders 24/7 with a customizable storefront that converts visitors into paying customers</p>
								</div>
								<div className="feature-item">
									<h4>No More Back-and-Forth</h4>
									<p>Customers can easily see what's in stock, so they can place their orders without having to message you first.</p>
								</div>
							</div>
						</div>
						<div className="feature-image bordered-image storefront-image" >
							<img src="landing-page/storefront.png" alt="Invoice and Payment Tracking" />
						</div>
					</div>

					<div className="feature-highlight" style={{ marginBottom: '100px' }}>
						<div className="feature-content">
							<h2>Smart Inventory Management</h2>
							<div className="feature-list">

								<div className="feature-item">
									<h4>Prevent stockouts</h4>
									<p>Prevent stockouts and overstock with real-time inventory tracking and low-stock alerts</p>
								</div>
							</div>
						</div>
						<div className="feature-image">
							<img src="landing-page/smart-inventory-management.png" alt="Smart Inventory Management" />
						</div>
					</div>

					<div className="feature-highlight reverse">
						<div className="feature-content">
							<h2>Business Intelligence That Drives Growth</h2>
							<div className="feature-list">
								<div className="feature-item">
									<h4>Revenue Analytics Dashboard</h4>
									<p>Discover your most profitable products, peak sales periods, and growth opportunities</p>
								</div>
								<div className="feature-item">
									<h4>Expense Tracking</h4>
									<p>Control costs and maximize profits by tracking every business expense in one place</p>
								</div>
							</div>
						</div>
						<div className="feature-image">
							<img src="landing-page/responsive-analytics.png" alt="Business Analytics" />
						</div>
					</div>
				</div>
			</section>

			<section className="testimonials" id="testimonials">
				<div className="container">
					<h2 className="section-title">Don't just take our word for it.</h2>
					<div className="testimonials-wrapper">
						<div className="testimonial-main">
							<div className="testimonial-content">
								<p className="testimonial-text large">"Running a small skincare brand, I used to rely on messy spreadsheets and notes to track my stock. Now, everything is in one place, and I get alerts before anything runs out. It's saved me time, money, and a lot of frustration!"</p>
								<div className="testimonial-author">
									<div className="testimonial-info">
										<h4>Maame Afua Konadu</h4>
									</div>
								</div>
							</div>
						</div>
						<div className="testimonials-sidebar">
							<div className="testimonial-small">
								<p>"We used to throw out so many expired products because we didn't have a proper tracking system. Since using VendReady, we’ve cut down waste dramatically and always have the right amount of stock on hand. It's a no-brainer for any food business!"</p>
								<cite>- Eseosa Oshodin</cite>
							</div>
							<div className="testimonial-small">
								<p>"As someone who sells exclusively through Instagram, VendReady has been a game-changer. I can manage everything from my phone while still creating content."</p>
								<cite>- Janice Asare</cite>
							</div>
							{/* <div className="testimonial-small">
								<p>"Finally, everything in one place. No more spreadsheet chaos"</p>
								<cite>- John Smith, Retailer</cite>
							</div> */}
						</div>
					</div>
				</div>
			</section>

			<section id="pricing" className="pricing-section">
				<div className="container">
					{/* <h2 className="section-title">Three ways we save your company both time and money.</h2>
					<div className="savings-grid">
						<div className="savings-item">
							<div className="savings-icon">⏰</div>
							<h3>Save precious time</h3>
							<p>Automate repetitive tasks and streamline operations. Our customers save an average of 10 hours per week on inventory and order management.</p>
						</div>
						<div className="savings-item">
							<div className="savings-icon">💰</div>
							<h3>Reduce operational costs</h3>
							<p>Eliminate costly stockouts and overstock situations. Track expenses and identify your most profitable products to maximize margins.</p>
						</div>
						<div className="savings-item">
							<div className="savings-icon">📈</div>
							<h3>Increase revenue</h3>
							<p>Never miss a sale with 24/7 storefront availability and real-time inventory tracking. Get paid faster with professional invoicing.</p>
						</div>
					</div> */}

					<div className="pricing-plans">
						<h3 className="pricing-title">For startups, global enterprises, and everyone in between</h3>
						<p className="pricing-subtitle">Choose the plan that grows with your business</p>

						<div className="pricing-toggle">
							<span className={`toggle-label ${billingInterval === 'monthly' ? 'active' : ''}`}>Monthly</span>
							<div className="toggle-switch" onClick={() => setBillingInterval(billingInterval === 'monthly' ? 'yearly' : 'monthly')}>
								<div className={`toggle-slider ${billingInterval === 'yearly' ? 'yearly' : ''}`}></div>
							</div>
							<span className={`toggle-label ${billingInterval === 'yearly' ? 'active' : ''}`}>
								Yearly
								<span className="save-badge">Save up to 10%</span>
							</span>
						</div>

						<div className="pricing-grid">
							<div className="pricing-card">
								<div className="pricing-header">
									<h4>Starter</h4>
									<div className="price-display">
										<span className="price">GHS {billingInterval === 'monthly' ? '40' : '450'}</span>
										<span className="period">/{billingInterval === 'monthly' ? 'month' : 'year'}</span>
									</div>
									<p>Perfect for new businesses</p>
								</div>
								<ul className="features-list">
									<li>50 Sales per month</li>
									<li>50 Products</li>
									{/* <li>25 Promo Messages</li> */}
									<li>Analytics</li>
									<li>Email Support</li>
									{/* <li>Invoice Read Receipts</li> */}
								</ul>
								<Link to={routes.REGISTER} className="btn btn-outline btn-block">Start 14-Day Trial</Link>
							</div>

							<div className="pricing-card featured">
								<div className="popular-badge">Most Popular</div>
								<div className="pricing-header">
									<h4>Growth</h4>
									<div className="price-display">
										<span className="price">GHS {billingInterval === 'monthly' ? '80' : '900'}</span>
										<span className="period">/{billingInterval === 'monthly' ? 'month' : 'year'}</span>
									</div>
									<p>For growing businesses</p>
								</div>
								<ul className="features-list">
									<li>500 Sales per month</li>
									<li>500 Products/Services</li>
									<li>3 Team Members</li>
									{/* <li>200 Promo Messages</li> */}
									<li>Analytics</li>
									<li>Email Support</li>
									<li>Invoice Read Receipts</li>
									<li>Online Store</li>
								</ul>
								<Link to={routes.REGISTER} className="btn btn-primary btn-block">Start 14-Day Trial</Link>
							</div>

							<div className="pricing-card">
								<div className="pricing-header">
									<h4>Business+</h4>
									<div className="price-display">
										<span className="price">GHS {billingInterval === 'monthly' ? '140' : '1,600'}</span>
										<span className="period">/{billingInterval === 'monthly' ? 'month' : 'year'}</span>
									</div>
									<p>For expanding operations</p>
								</div>
								<ul className="features-list">
									<li>Unlimited Sales</li>
									<li>Unlimited Products/Services</li>
									<li>Unlimited Team Members</li>
									{/* <li>1,000 Promo Messages</li> */}
									<li>Analytics</li>
									<li>Email Support</li>
									<li>Invoice Read Receipts</li>
									<li>Online Store</li>
								</ul>
								<Link to={routes.REGISTER} className="btn btn-outline btn-block">Start 14-Day Trial</Link>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section className="final-cta">
				<div className="container">
					<div className="cta-content">
						<h2>What would you do with more time?</h2>
						<p>Stop wasting time on manual inventory management and order tracking. Join thousands of business owners who have transformed their operations with VendReady.</p>
						<div className="cta-buttons">
							<Link to={routes.REGISTER} className="btn btn-primary btn-large">Start Your Free Trial</Link>
							<p className="cta-guarantee">14-day free trial • No credit card required • Cancel anytime</p>
						</div>
					</div>
					{/* <div className="trust-indicators">
						<div className="trust-item">
							<span className="trust-icon">🔒</span>
							<span>Enterprise Security</span>
						</div>
						<div className="trust-item">
							<span className="trust-icon">📱</span>
							<span>Works Everywhere</span>
						</div>
						<div className="trust-item">
							<span className="trust-icon">⚡</span>
							<span>Setup in Minutes</span>
						</div>
					</div> */}
				</div>
			</section>

			<footer className="main-footer">
				<div className="container">
					<div className="footer-content">
						<div className="footer-section">
							<div className="footer-logo">VendReady</div>
							<p>Built by business owners, for business owners. The complete solution for inventory and order management that actually works.</p>
						</div>
						<div className="footer-section">
							<h4>Product</h4>
							<ul>
								<li><a href="#features">Features</a></li>
								<li><a href="#pricing">Pricing</a></li>
								<li><Link to={routes.REGISTER}>Free Trial</Link></li>
							</ul>
						</div>
						{/* <div className="footer-section">
							<h4>Company</h4>
							<ul>
								<li><a href="#about">About</a></li>
								<li><a href="#contact">Contact</a></li>
								<li><a href="#support">Support</a></li>
							</ul>
						</div> */}
					</div>
					<div className="footer-bottom">
						<p>&copy; 2025 VendReady. All rights reserved.</p>
					</div>
				</div>
			</footer>
		</div>
	);
}